import { type FC, type ReactNode } from "react";
import { Button } from "~/common/components/Button/Button";

export const CloseBtn: FC<{
  children?: ReactNode;
  href?: string;
  onClick?: () => void;
  disabled?: boolean;
  fullWidth?: boolean;
}> = (props) => {
  return <Button variant={"text"} data-test-id={"add-to-cart-btn-cancel"} {...props} />;
};
